











import { Component, Prop, Vue } from 'vue-property-decorator';
import { BadgesType } from './types';

@Component
export default class ListCardBadge extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly badges!: BadgesType;

  @Prop({ type: Number, default: 3000 })
  interval: number;

  curr: number = 0;
  timer: number | null = null;

  mounted() {
    if (this.badges && this.badges.length > 1) {
      this.timer = window.setInterval(() => {
        let next = this.curr + 1;
        this.curr = next < this.badges.length ? next : 0;
      }, this.interval);
    }
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/ListCardBadge/ListCardBadge.vue